import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {SnackbarService} from "../../../../shared/services/snackbar.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SlugTransformDirective} from "../../../../shared/directives/slug-transform.directive";

@Component({
  selector: 'app-category-settings',
  standalone: true,
  imports: [
    CardsBasicComponent,
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatCheckboxModule,
    SlugTransformDirective,
    TranslateModule
  ],
  templateUrl: './category-settings.component.html',
  styleUrl: './category-settings.component.css'
})
export class CategorySettingsComponent implements OnInit, OnDestroy {
  productId!: number;
  categoryId!: number
  categoryData!: any;
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    public _languageService: LanguageService,
    private _translate: TranslateService,
    private _route: ActivatedRoute,
    private _router: Router) {
  }

  ngOnInit() {
    this.setupLanguageSubscription();
    this.getRouteParams();
  }

  getRouteParams() {
    this.subscriptions.add(
      this._route.params.subscribe(params => {
        this.categoryId = this._route.snapshot.parent?.params['categoryId'];
      })
    );

    if (!isNaN(Number(this.categoryId))) {
      this.loadCategoryData();
    } else {
      this.createEmptyCategory();
    }
  }


  createEmptyCategory() {
    const translations: { [key: string]: { name: string, slug: string } } = {};

    this._languageService.supportedLangs.forEach(lang => {
      translations[lang] = {
        name: '',
        slug: ''
      };
    });

    this.categoryData = {
      translations: translations
    };
  }


  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }


  private loadCategoryData() {
    this.subscriptions.add(
      this._apiService.fetchCategory(this.categoryId).subscribe({
        next: (response: any) => {
          this.categoryData = response;
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  private createCategory() {
    this.subscriptions.add(
      this._apiService.createCategory(this.categoryData).subscribe({
        next: (response: any) => {
          this.categoryData = response.data;
          this._snackbarService.show(response.message);
          this.updateUrl();
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  private updateCategory() {

    this.subscriptions.add(
      this._apiService.updateCategory(this.categoryData).subscribe({
        next: (response: any) => {
          this.categoryData = response.data;
          this._snackbarService.show(response.message);
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  saveCategory() {
    this.categoryData.id ? this.updateCategory() : this.createCategory();
  }

  cancel() {
    this.categoryData.id ? this.loadCategoryData() : this.createEmptyCategory();
  }

  private updateUrl(): void {
    this._router.navigateByUrl(this._router.url.replace(String(this.categoryId), String(this.categoryData.id)));
    this.categoryId = this.categoryData.id;
  }

  ngOnDestroy() {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

}
